import { render } from "./CustomTabs.vue?vue&type=template&id=ae164512"
import script from "./CustomTabs.vue?vue&type=script&lang=js"
export * from "./CustomTabs.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__